import { render } from "./ManagePackage.vue?vue&type=template&id=4d0ed72c&scoped=true"
import script from "./ManagePackage.vue?vue&type=script&lang=js"
export * from "./ManagePackage.vue?vue&type=script&lang=js"

import "./ManagePackage.vue?vue&type=style&index=0&id=4d0ed72c&scoped=true&lang=css"
import "./ManagePackage.vue?vue&type=style&index=1&id=4d0ed72c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0ed72c"]])

export default __exports__